import { upperFirst } from 'lodash';

import getDataDst from 'ia-react-core/~/utils/components/_getDataDst';
import getValuesDst from 'ia-react-core/~/utils/components/_getValuesDst';
import Schema, { DataDstProps, SchemaDecorateComponentOptions, ValuesDstProps } from '../Schema';

export interface SuffixSchemaOptions {
  strict?: boolean;
  autoFix?: boolean;
}

export default class SuffixSchema extends Schema {
  getName<
  Props extends(DataDstProps | ValuesDstProps) & Record<string, unknown>
>(type: string, props: Props, { idType, prefixType }: SchemaDecorateComponentOptions) {
    const name = super.getName(type, props, { idType, prefixType });

    const shouldFix = (
      this.autoFix &&
      name &&
      !name.endsWith(upperFirst(prefixType)) &&
      !name.startsWith(upperFirst(prefixType))
    );

    const resolvedName = shouldFix ?
      `${name}${upperFirst(prefixType)}` :
      name;

    return resolvedName;
  }

  extendName(type: string, props: Record<string, unknown>) {
    const { name } = props;
    return `${name as string}${upperFirst(type)}`;
  }

  getValuesDst(props: ValuesDstProps, defaultValue = `${props.name}Values`) {
    return getValuesDst(props) || defaultValue;
  }

  getDataDst(props: DataDstProps, defaultValue = `${props.name}Data`) {
    return getDataDst(props) || defaultValue;
  }

  decorateComponent<
    Props extends(
DataDstProps | ValuesDstProps) & Record<string, unknown>
  >(
    type: string,
    props: Props,
    { idType = `${type}Id`, prefixType = type }: SchemaDecorateComponentOptions = {},
  ): Props {
    const name = this.getName(type, props, { idType, prefixType });

    const newProps = {
      name,
    } as Props;

    const defaultValue = (props.name && this.autoFix) ? this.removeCategories(newProps.name) : undefined;

    if (type === 'resource') {
      (newProps as DataDstProps).dataDst = this.getDataDst({ name: newProps.name, ...props }, defaultValue);
    } else if (type === 'form' || type === 'workflow') {
      (newProps as ValuesDstProps).valuesDst = this.getValuesDst({ name: newProps.name, ...props }, defaultValue);
    }

    return newProps;
  }
}
